<template>
    <div class="shopping_cart_box bar_content_box" id="shopping_cart_box">
        <div class="content_title fix">
            <div class="f-fl font_color">
                <i class="detail_ico_25 problem_blue_ico">
                    <img class="faq_ico" src="https://resource.rcclchina.com.cn/tui2/detail/faq.png">
                </i> 常见问题Top10
            </div>
            <div class="f-fr" id="close_btn" @click="closeMenu">
                <i role="button" class="detail_ico_25 close_block_ico">
                    <img src="https://resource.rcclchina.com.cn/tui2/detail/close.png">
                </i>
            </div>
        </div>

        <div class="shopping_cart_list content_box">
            <div class="list_box faqItem" v-for="(item) in faqItems" :key="('faq_'+item.id)"
            @click="onTopFaqClick(item)">
                <span class="faqItem-title">{{item.title}}</span> 
                <img class="faq-hot" src="https://resource.rcclchina.com.cn/Home/new/faq-hot.png">
            </div>
        </div>

        <div class="bottom_btn" id="shoppingCart_NextButton" @click="goFaq">
            查看更多常见问题
        </div>

        <TopFaqPopup 
            :faqItem="targetFaq"
            :isShow="isShowPopup"
            v-on:onModalClose="isShowPopup=false"
        />

    </div>
</template>

<script>
import api from '@/api'
const TopFaqPopup = () => import('@/components/FloatMenu/TopFaqPopup')
export default {
    name: "TopFaq",
    components: {
        TopFaqPopup
    },
    props: {
        closeMenu: {
            type: Function
        },
    },
    data () {
        return {
            faqItems: [],
            isShowPopup: false,
            targetFaq: {}
        }
    },
    beforeMount () {
        this.initPage ()
    },
    methods: {
        async initPage () {
            const { success, data } = await api.page.getTopFaq({
                offset: 0,
                limit: 100
            })
            this.isShow = true
            if (success && data) {
                this.faqItems = data
            }
        },
        onTopFaqClick (faqItem) {
            this.targetFaq = faqItem
            this.isShowPopup = true
        },
        goFaq () {
            window.open('/content/faq')
        }
    },
    computed: {
        
    },
    watch: {
        
    }
}
</script>

<style lang="less" scoped>
.bar_content_box {
    position: relative;
    height: 100%;
    overflow: initial;
    padding: 40px 0px;
    .content_title {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        font-size: 16px;
        font-weight: bold;
        background: #e5f4ff;
        padding: 7px 10px 7px 0px;
        .font_color {
            color: black;
        }
        .wishlist_ico {
            position: relative;
            padding-left: 8px;
            top: -1px;
        }
    }
   
    .shopping_cart_list {
        position: absolute;
        top: 40px;
        bottom: 40px;
        width: 100%;
        margin: 0;
        overflow-y: auto;
        font-size: 12px;
        background: white;
        padding-bottom: 30px;
    }


    .bottom_btn {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #282b2c;
        background: #fbc500;
        text-align: center;
        cursor: pointer;
        font-weight: 500;
    }

    .list_box {
        padding: 10px;
        color: #282b2c;
        line-height: 1.8;
        cursor: pointer;
        border-bottom: 10px solid #f2f1ed;
        .faqItem-title {
            font-size: 13px;
        }
    }

    .faq_ico {
        position: relative;
        padding-left: 8px;
        top: -1px;
    }
    
}
</style>